import { CardElement, CardElementProps, PaymentRequestButtonElement } from "@stripe/react-stripe-js";
import { PaymentRequest, StripeCardElementChangeEvent, StripeCardElementOptions } from "@stripe/stripe-js";
import { useBrowser, useToast } from "~/utils";
import { Content } from "~/components/aud/base/Content";
import { SectionTitle } from "~/components/aud/base/Section";
import { useCallback } from "react";
import { Theme } from "~/types/theme";
import classnames from "classnames";
import css from "./SelectSubscriptionPayment.module.scss";

const createOptions = (theme: Theme): StripeCardElementOptions => ({
  style: {
    base: {
      color: theme === "light" ? "#222" : "#fff",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
      padding: "16px",
    },
    invalid: {
      color: "#ED2B75",
    },
  },
});

const CustomCardElement: React.FC<
  CardElementProps & {
    theme: Theme;
  }
> = ({ theme, ...props }) => {
  const toast = useToast();

  const onChange = useCallback(
    (event: StripeCardElementChangeEvent) => {
      if (event.error) {
        toast.error(event.error.message);
      }
      return props.onChange?.(event);
    },
    [props.onChange]
  );

  return <CardElement {...props} onChange={onChange} options={createOptions(theme)} />;
};

const PaymentRequestForm: React.FC<{
  paymentRequest: PaymentRequest;
}> = ({ paymentRequest }) => {
  const browser = useBrowser();
  return (
    <div className="field">
      <span className="label">
        {browser?.getBrowserName() == "Chrome" ? "Google Payで支払う" : "Apple Payで支払う"}
      </span>
      <div className="stripe">
        <PaymentRequestButtonElement options={{ paymentRequest }} />
      </div>
    </div>
  );
};

export const SelectSubscriptionPayment: React.FC<{
  paymentRequest: PaymentRequest | null;
  onChangeStripeForm: Exclude<CardElementProps["onChange"], undefined>;
  theme: Theme;
  planId: string;
}> = ({ paymentRequest, onChangeStripeForm, theme, planId }) => (
  <Content>
    <SectionTitle theme={"dark"}>支払い方法を選択</SectionTitle>
    <div className="_form">
      {paymentRequest && (
        <>
          <PaymentRequestForm paymentRequest={paymentRequest} key={planId} />
          <div className="_hr withText">
            <span>または</span>
          </div>
        </>
      )}
      <div className="field">
        <span className={classnames(["label", css.label])}>クレジットカードで支払う</span>
        <div className="stripe">
          <CustomCardElement onChange={onChangeStripeForm} theme={theme} />
        </div>
      </div>
    </div>
  </Content>
);

type UpdateSubscriptionPaymentProps = {
  onChange: Exclude<CardElementProps["onChange"], undefined>;
  theme: Theme;
};
export const UpdateSubscriptionPayment: React.FC<UpdateSubscriptionPaymentProps> = ({ onChange, theme }) => (
  <Content>
    <div className="_form">
      <span className="label">クレジットカード番号</span>
      <div className="field">
        <div className="stripe">
          <CustomCardElement onChange={onChange} theme={theme} />
        </div>
      </div>
    </div>
  </Content>
);
